import { html } from 'lit';

export const closeIcon = html`<svg
  version="1.1"
  id="Layer_1"
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink"
  x="0px"
  y="0px"
  width="18px"
  height="18px"
  viewBox="0 0 18 18"
  enable-background="new 0 0 18 18"
  xml:space="preserve"
>
  <path
    d="M3.3,13.2l1.4,1.4L9,10.4l4.2,4.2l1.4-1.4L10.4,9l4.2-4.2l-1.4-1.4L9,7.6L4.8,3.3L3.3,4.8L7.6,9L3.3,13.2z"
  />
</svg>`;
